import { ReactNode, useMemo } from 'react';

import styled from '@emotion/styled';
import { StyledCard } from './StyledCard';
import { Responsive } from '../../utils';
import { FixedGrid, IFixedGridProps } from '../Grid';
import {
	CardContainerContext,
	ICardContainerContextValues,
} from './CardContainerContext';
import { IStyledComponentSelector } from '../../types';
import { UnstyledUl } from '../List';

export type CardOrientation = 'horizontal' | 'vertical';

export interface ICardsContainerProps extends ICardContainerContextValues {
	children: ReactNode;
	columns: Responsive.IValueOrResponsiveValue<number>;
	itemSelector?: IStyledComponentSelector;
}

interface IStyledCardsContainerProps extends IFixedGridProps {
	fullyClickable?: boolean;
}

const StyledCardsContainer = styled(
	FixedGrid.withComponent(UnstyledUl),
)<IStyledCardsContainerProps>``;

export function CardsContainer({
	children,
	columns,
	itemSelector = StyledCard,
	...rest
}: ICardsContainerProps) {
	const restValue = useMemo(
		() => ({ itemSelector, ...rest }),
		[itemSelector, rest],
	);

	return (
		<CardContainerContext.Provider value={restValue}>
			<StyledCardsContainer
				columns={columns}
				itemSelector={itemSelector}
				{...rest}
			>
				{' '}
				{children}
			</StyledCardsContainer>
		</CardContainerContext.Provider>
	);
}
